// extracted by mini-css-extract-plugin
export default {"cls1":"SocialActionsMenu-cls1_c86","cls2":"SocialActionsMenu-cls2__7x SocialActionsMenu-cls1_c86"};